<template>

    <div class="modal-add-account">
        <div class="modal-add-account-content">
            <div class="cross-button" @click="$emit('close')">
                <img src="@/assets/images/close.svg" alt="cross" />
            </div>
            <div class="left" :style="{backgroundImage: 'url(' + require('@/assets/images/left.jpg') + ')' }"></div>

            <div class="right"><br /><br />
                <div class="title">Add new account</div><br />
                <div class="form">
                    <b-row>
                        <b-col
                        md="6"
                        xl="6"
                        
                        >
                            
                            <b-form-group
                                label="First name*"
                                label-for="basicInput"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="First name"
                                        rules="required"
                                        >
                                    <b-form-input
                                    
                                    id="basicInput"
                                    type="text"
                                    v-model="form.name"
                                    :state="errors.length > 0 ? false:null"
                                   
                                    placeholder="First name*"
                                    
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group> 
                        </b-col>
                        <b-col
                        md="6"
                        xl="6"
                       
                        >
                            
                            <b-form-group
                                label="Last name*"
                                label-for="basicInput"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="Last name"
                                        rules="required"
                                        >
                                    <b-form-input
                                    
                                    id="basicInput"
                                    type="text"
                                    v-model="form.surname"
                                    :state="errors.length > 0 ? false:null"
                                   
                                    placeholder="Last name*"
                                    
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group> 
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col
                        md="6"
                        xl="6"
                        
                        >
                            
                            <b-form-group
                                label="Company*"
                                label-for="basicInput"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="Company"
                                        rules="required"
                                        >
                                    <b-form-input
                                    
                                    id="basicInput"
                                    type="text"
                                    v-model="form.brand_name"
                                    :state="errors.length > 0 ? false:null"
                                   
                                    placeholder="Company*"
                                    
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group> 
                        </b-col>
                        <b-col
                        md="6"
                        xl="6"
                       
                        >
                            
                            <b-form-group
                                label="Phone"
                                label-for="basicInput"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="Phone"
                                        rules="phone"
                                        >
                                    <b-form-input
                                    
                                    id="basicInput"
                                    type="text"
                                    v-model="form.phone"
                                    :state="errors.length > 0 ? false:null"
                                    placeholder="Phone"
                                    
                                    />
                               
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group> 
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col
                        md="6"
                        xl="6"
                      
                        >
                            
                            <b-form-group
                                label="Email*"
                                label-for="basicInput"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="Email"
                                        rules="required|email"
                                        >
                                    <b-form-input
                                    
                                    id="basicInput"
                                    type="email"
                                    v-model="form.email"
                                    :state="errors.length > 0 ? false:null"
                                   
                                    placeholder="Email*"
                                    
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group> 
                        </b-col>
                        <b-col
                        md="6"
                        xl="6"
                     
                        >
                            
                            <b-form-group
                                label="Password*"
                                label-for="basicInput"
                            >
                                <validation-provider
                                        #default="{ errors }"
                                        name="Password"
                                        rules="required"
                                        >
                                    <b-form-input
                                    
                                    id="basicInput"
                                    type="password"
                                    v-model="form.password"
                                    :state="errors.length > 0 ? false:null"
                                   
                                    placeholder="Password*"
                                    
                                    />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group> 
                        </b-col>
                    </b-row>
                    <div class="checkbox-container">
                        <b-form-checkbox v-model="form.separate_bill" switch >Bill this account separately</b-form-checkbox>
                    </div>
                    <br />
                    
                    <b-button @click="createAccount" variant="secondary" class="w-100 text-align-left" >Add account</b-button><br /><br />
                </div>
            </div>
            
        </div>
    </div>
   
</template>
    
<script>
    import {BModal, BButton, BRow, BFormCheckbox, BCol, VBModal,BOverlay, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'

    import { VueGoodTable } from 'vue-good-table'
    import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
    import { ValidationProvider, ValidationObserver } from 'vee-validate'
    import { required, email, phone } from '@validations'
    import { Auth } from '@simb2s/senseye-sdk'
    export default {
      components: {
        BCard,
        BCardText,
        BRow,
        BFormCheckbox,
        BCol,
        VueGoodTable,
        BAvatar,
        BBadge,
        BPagination,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BDropdown,
        BDropdownItem,
        BModal,
        BOverlay,
        BButton,
        ValidationProvider,
        ValidationObserver
      },
      data() {
        return {
            validation: true,
            form:{
                name:"",
                surname: "",
                username:"",
                brand_name:"",
                phone:"",
                email:"",
                password: "",
                separate_bill: false
            },
            required,
            phone,
            email
        }
      },
      methods:{
        async createAccount()
        {
          console.log(this.form)
          let datas=this.form
          datas.main_user={id:this.$user.id}
          datas.username=this.form.email
          let $register = await Auth.registerBrand(datas)

            if($register && $register.status == 200){

                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Account created successfully!',
                        icon: 'CheckIcon',
                        variant: 'success',
                    },
                })
                this.$emit('close')
                let new_account=await Auth.get_user(this.form.email)
                if(new_account.separate_bill==false)
                {
                    this.$emit('displaySubscriptionPopup',$register.success)
                }
                
                
                if(!this.$user.sub_accounts)
                {
                  this.$user.sub_accounts=[]
                }
                this.$user.sub_accounts.push(new_account)
                }
            }
      },
      watch:{
       
      },
      async mounted()
      {
      
       
      }
    }
    </script>
    
    <style lang="scss" scoped>
    @import '@core/scss/vue/libs/vue-good-table.scss';
    .checkbox-container
    {
        display:flex;
        flex-direction:row;
        justify-content:flex-start;
        align-items:center;
    }
    .custom-switch .custom-control-label
    {
        padding-left:0px !important;
        color:#999;
        padding-top:8px !important;
        font-size:13px !important;
    }
    .cross-button
    {
        position:absolute;
        top:20px;
        right:20px;
        cursor:pointer;
        width:40px;
        height:40px;
        background:#f1f1f1;
        border-radius:5px;
        display:flex;   
        align-items:center;
        justify-content:center;
        img{
            width:12px;
        }
    }
    .modal-add-account
    {
        position:fixed;
        top:0;
        left:0;
        width:100%;
        height:100%;
        background:rgba(0,0,0,0.15);
        backdrop-filter:blur(15px);
        -webkit-backdrop-filter:blur(10px);
        z-index:99999999;
        display:flex;
        justify-content:center;
        align-items:center;
    }
    .modal-add-account-content
    {
        position:relative;
        width:80%;
        background:#fff;
        border-radius:5px;
        overflow:hidden;
        display:flex;
        flex-direction:row;
        justify-content:flex-start;
        align-items:stretch;
    }
    .right
    {
        padding:20px;
        width:60%;
        flex:1;
        display:flex;
        flex-direction:column;
        justify-content:space-between;
        align-items:flex-start;
    }
    .left
    {
        width:40%;
        flex-shrink:0;
        align-self:stretch;
        min-height:100%;
        background-size:cover;
        background-position:center;
        background-repeat:no-repeat;
        border-radius:5px 0 0 5px;
    }
    .title
    {
        font-size:40px;
        font-weight:600;
    }
    .form
    {
        flex:1;
        width:100%;
    }
    .custom-control-label
    {
        font-size:13px !important;
    }
    </style>
    